import { SandboxProvider, updateSandbox, useSandboxDispatch, useSandboxState } from './context01'
import UseEffectPropertySandbox from './Sandbox'

export default function UseEffectPropertySandboxWrapper() {
  return (
    <SandboxProvider>
      <UseEffectPropertySandbox />
    </SandboxProvider>
  )
}